import { useEffect,useState } from 'react';

import { useAppDispatch } from 'app/hooks';
import {
    setSaveButtonEnabled
} from 'common/components/EditDrawer/editDrawerSlice';

export type DateValidation = {
    isError: boolean,
    errorMessage: string
}

export function useDateValidation(startDate: string, endDate: string): DateValidation {
    const [error, setError] = useState<{isError: boolean, errorMessage: string}>({
        isError: false,
        errorMessage: ''
    });
    const dispatch = useAppDispatch();
    const ERROR_MESSAGE = 'The start date must be before the end date.';

    const _checkDatesInRange = (startDateParam: string, endDateParam: string) => {
        const convertedStartDate = new Date(startDateParam).getTime();
        const convertedEndDate = new Date(endDateParam).getTime();

        if(convertedStartDate >= convertedEndDate) {
            setError({
                isError: true,
                errorMessage: ERROR_MESSAGE
            });
            dispatch(setSaveButtonEnabled(false));
        } else {
            setError({
                isError: false,
                errorMessage: ''
            });
            dispatch(setSaveButtonEnabled(true));
        }
    };

    const _isEmptyDate = (startDateParam: string, endDateParam: string): boolean => !startDateParam || !endDateParam;

    useEffect(() => {
        if(_isEmptyDate(startDate, endDate)) {
            dispatch(setSaveButtonEnabled(false));
        }
        _checkDatesInRange(startDate, endDate);
    }, [startDate, endDate, dispatch]);

    return error;
}
